module.exports = __webpack_public_path__ + "img/QC.d6296277.png";